export default "__VITE_ASSET__C3V5hp81__"